module.exports = __webpack_public_path__ + "img/orange-glorius.850a243f.jpg";